// extracted by mini-css-extract-plugin
export default {"main":"_80aa60c269","tit":"_6c74248223","maintitle":"df37ae123d","ylw":"_592e4b1316","white":"_6a6dfda201","mv_title":"_01b547e690","mv_nc":"_56af7285f7","mv_in":"b2ad013c5b"};